export function isExternalLink(link?: string | null): boolean {
    return !!link && !link.startsWith('/');
}
